module.exports = __webpack_public_path__ + "img/Lock.1dcce335.svg";